import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=02465b43&"
import script from "./Preloader.vue?vue&type=script&lang=ts&"
export * from "./Preloader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports